<template>
  <div class="module-title">
    <div class="decoration">
      <span class="dot top-left"></span>
      <span class="dot top-right"></span>
      <span class="dot bottom-right"></span>
      <span class="dot bottom-left"></span>
    </div>

    <div class="title">
      <span class="icon"></span>
      <text-box :mode="mode" :value="title || '标题'" @onChange="value => handleTitleChange(value)">
        {{ title || "标题" }}
      </text-box>
    </div>
    <div class="title-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
// components
import TextBox from "./TextBox";
export default {
  name: "ModuleTitle",
  components: {
    TextBox
  },
  props: {
    mode: String,
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  mounted() {},

  methods: {
    handleTitleChange(title) {
      this.$emit("onChange", title);
    }
  }
};
</script>

<style lang="less" scoped>
.module-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  background: #e9e9ec;
  padding: 10px 9px 12px 21px;
  border-radius: 8px 8px 0px 0px;
  font-size: 14px;
  font-weight: bold;
  color: #212121;
  line-height: 22px;
  .decoration {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .dot {
      position: absolute;
      display: inline-block;
      width: 4px;
      height: 4px;
      background-color: #d8d8d8;
    }
    .top-left {
      left: 7px;
      top: 6px;
    }
    .top-right {
      right: 9px;
      top: 6px;
    }
    .bottom-right {
      right: 9px;
      bottom: 6px;
    }
    .bottom-left {
      left: 7px;
      bottom: 6px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    .icon {
      display: inline-block;
      vertical-align: middle;
      width: 5px;
      height: 18px;
      background: #7b87a6;
      border-radius: 3px;
      margin-right: 8px;
    }
  }
  .title-right {
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
  }
}
</style>
